import AdminCatalogueItemVariantList from './AdminCatalogueItemVariantList';

export default AdminCatalogueItemVariantList;
